import ModelProxy from "../model-proxy";
import {EntityType} from "../../gd/const/item";
import ModelEntity from "../model-entity";
import {DependencyType} from "./const";
import DatetimeUtils from "../../gd/utils/datetime-utils";
import Task from "../task/task";
import Project from "../project/project";
import Event from "../event/event";

const debug = false
// const debug = "DependencyModel"

export default class Dependency extends ModelEntity {


    // public id : ID

    public event1Id     : ID | null
    public event2Id     : ID | null
    public project1Id   : ID | null
    public project2Id   : ID | null
    public task1Id      : ID | null
    public task2Id      : ID | null

    public type         : DependencyType

    public firstRID     : RID   // first (predecessor? ResourceID)
    public secondRID    : RID   // second (successor? ResourceID)

    public successor?   : Task | Project | Event
    public predecessor? : Task | Project | Event


    constructor(data:any, options={}) {
        super(data['id'], EntityType.DEPENDENCY);

        // Not sure if we still use start->finish maybe yes maybe no but for legecay at least
        if (data.type === DependencyType.START_FINISH) {
            data = this.convertStartFinishToFinishStart(data)
        }

        this.type           = data.type
        this.event1Id       = data.event1Id
        this.event2Id       = data.event2Id
        this.task1Id        = data.task1Id
        this.task2Id        = data.task2Id
        this.project1Id     = data.project1Id
        this.project2Id     = data.project2Id

        this.firstRID       = this.initFirstRID()
        this.secondRID      = this.initSecondRID()
        this.successor      = data.successor ? this.initSuccessor(data.successor) : undefined
        this.predecessor    = data.predecessor ? this.initPredecessor(data.predecessor): undefined

        const useProxy = _.get(options, 'useProxy', true)
        return useProxy ? new Proxy(this, ModelProxy) : this;
    }

    get predecessorType(): EntityType | undefined {
        if (this.task1Id) {
            return EntityType.TASK
        }
        if (this.project1Id){
            return EntityType.PROJECT
        }
        if (this.event1Id){
            return EntityType.EVENT
        }
    }
    get successorType(): EntityType | undefined {
        if (this.task2Id) {
            return EntityType.TASK
        }
        if (this.project2Id){
            return EntityType.PROJECT
        }
        if (this.event2Id){
            return EntityType.EVENT
        }
    }


    private convertStartFinishToFinishStart(data: any) {
        return {
            type:       DependencyType.FINISH_START,
            task1Id:    data.task2Id,
            task2Id:    data.task1Id,
            project1Id: data.project2Id,
            project2Id: data.project1Id,
            event1Id:   data.event2Id,
            event2Id:   data.event1Id
        }
    }

    private initFirstRID():RID {
        if (this.task1Id) return this.initRID(EntityType.TASK, this.task1Id)
        if (this.project1Id) return this.initRID(EntityType.PROJECT, this.project1Id)
        if (this.event1Id) return this.initRID(EntityType.EVENT, this.event1Id)

        console.warn("SOMETHING WRONG WITH DEPENDENCY #DEPENDECY-1")

        return 'DEPENDENCY-ERROR-1' as RID
    }

    private initSecondRID():RID {
        if (this.task2Id) return this.initRID(EntityType.TASK, this.task2Id)
        if (this.project2Id) return this.initRID(EntityType.PROJECT, this.project2Id)
        if (this.event2Id) return this.initRID(EntityType.EVENT, this.event2Id)

        console.warn("SOMETHING WRONG WITH DEPENDENCY #DEPENDECY-2")

        return 'DEPENDENCY-ERROR-2' as RID
    }

    private initPredecessor(predecessorData: any): Task | Event | Project | undefined {
        if (!predecessorData){
            return
        }
        if (this.task1Id) return new Task(predecessorData)
        if (this.project1Id) return new Project(predecessorData)
        if (this.event1Id) return new Event(predecessorData)
        console.warn("SOMETHING WRONG WITH DEPENDENCY in initPredecessor #DEPENDECY-3")
    }
    private initSuccessor(successorData: any): Task | Event | Project | undefined {
        if (!successorData){
            return
        }
        if (this.task2Id) return new Task(successorData)
        if (this.project2Id) return new Project(successorData)
        if (this.event2Id) return new Event(successorData)
        console.warn("SOMETHING WRONG WITH DEPENDENCY in initSuccessor #DEPENDECY-4")
    }

    toJSON() {
        const res: JSONObject = {
            id          : this.id,
            type        : this.type,

            event1Id    : this.event1Id,
            event2Id    : this.event2Id,
            project1Id  : this.project1Id,
            project2Id  : this.project2Id,
            task1Id     : this.task1Id,
            task2Id     : this.task2Id,
        }

        return res
    }

    // public convertDependencyToFirstSecond() {
    //
    //     const res = {type: dep.type};
    //
    //     const regExp = /(\w+)([1,2])Id/g;
    //
    //     _.mapKeys(dep, (value, key)=>{
    //         if (value) {
    //             let matchArr = key ? [...key.matchAll(regExp)] : [];
    //             const match = matchArr[0];
    //
    //             if (match) {
    //                 let prefix = '';
    //                 switch (match[1]) {
    //                     case 'task':    prefix = 't-'; break;
    //                     case 'project': prefix = 'p-'; break;
    //                     case 'event':   prefix = 'e-'; break;
    //                 }
    //
    //                 switch (match[2]) {
    //                     case '1': res.firstId = prefix + value; break;
    //                     case '2': res.secondId = prefix + value; break;
    //                 }
    //             }
    //         }
    //     })
    //
    //     return res;
    // }


}
